import Dialog from '@mui/material/Dialog';
import styled from 'styled-components';

export const Modal = ({ open, onClose, children }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      sx={{
        '& .MuiDialog-paper': {
          overflow: 'visible',
        },
      }}
    >
      <DialogBody>{children}</DialogBody>
    </Dialog>
  );
};

const DialogBody = styled.div`
  padding: 24px;
  border-radius: 8px;
`;
